module.exports = "<md-sidenav md-component-id=mainSidenav class=\"md-sidenav-left cloudAdmin-sidenav\" md-is-locked-open=\"$mdMedia('gt-md')\" layout-fill> <md-list> <md-list-item ng-repeat=\"link in $ctrl.links\" class=md-2-line ng-disabled=link.disabled ng-click=$ctrl.navigate(link.state)> <md-tooltip ng-if=link.disabled>Not implemented yet</md-tooltip> <md-icon md-svg-src={{link.icon}} alt=Start></md-icon> <div class=md-list-item-text> <h3>{{link.title}}</h3> <p>{{link.description}}</p> </div> </md-list-item> </md-list> </md-sidenav>";


//////////////////
// WEBPACK FOOTER
// ./app/layout/sidenav/sidenav.html
// module id = ./app/layout/sidenav/sidenav.html
// module chunks = 8